module.exports = __webpack_public_path__ + "img/wallet-right-arrow.886414a6.svg";